import { Link } from "react-router-dom";
import { Wrench, ShieldCheck, Sparkles, CheckCircle2 } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function ServiceLinksBlock() {
    const { t } = useLang();

    const services = [
        { icon: Wrench,        title: t.service_cards.maintenance_title, desc: t.service_cards.maintenance_desc, serviceType: "Maintenance" },
        { icon: ShieldCheck,   title: t.service_cards.itv_title,         desc: t.service_cards.itv_desc,         serviceType: "ITV" },
        { icon: Sparkles,      title: t.service_cards.track_title,       desc: t.service_cards.track_desc,       serviceType: "Track Prep" },
        { icon: CheckCircle2,  title: t.service_cards.diag_title,        desc: t.service_cards.diag_desc,        serviceType: "Diagnostics" },
    ];

    return (
        <section className="border-t border-black/10 bg-[--ls-paper]">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {services.map((s, i) => (
                        <Link
                            key={i}
                            to="/servicio"
                            state={{ serviceType: s.serviceType }}
                            className="glass p-7 hover:border-black/25 transition-colors block"
                        >
                            <s.icon size={24} style={{ color: "var(--ls-terracotta)" }} />
                            <h3 className="mt-6 font-display text-lg font-semibold">{s.title}</h3>
                            <p className="mt-3 text-sm text-neutral-500">{s.desc}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
